<script>
  import Button from '../common/Button.svelte';

  export let lang = undefined;
  export let onAccept;
  export let onReject;

  const i18n = {
    cookies: {
      cs: 'Tyto webové stránky používají soubory cookies.',
      en: 'This website uses cookies.',
    },
    accept: {
      cs: 'Přijmout',
      en: 'Accept',
    },
    reject: {
      cs: 'Odmítnout',
      en: 'Reject',
    },
  };
</script>

<div class='cookies-bar'>
  <div class='cookies-bar-content'>
    {i18n.cookies[lang]}
  </div>

  <div class='cookies-bar-buttons'>
    <div class='cookies-bar-buttons-accept'>
      <Button value={i18n.accept[lang]} onClick={onAccept} color='green' icon='done'/>
    </div>

    <div class='cookies-bar-buttons-reject'>
      <Button value={i18n.reject[lang]} onClick={onReject} color='red' icon='close'/>
    </div>
  </div>
</div>

<style>
  .cookies-bar {
    position: fixed;
    right: 0px;
    bottom: 0px;

    display: flex;
    flex-direction: column;
    gap: 20px;

    width: 500px;
    max-width: calc(100% - 120px);

    padding: 20px;

    margin: 40px;

    border-radius: 5px;

    z-index: 4;

    background: var(--grey-1);

    box-shadow: 0 0 10px 0 var(--grey-6);
  }

  .cookies-bar-content {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 40px;

    text-align: center;

    font-weight: bold;
  }

  .cookies-bar-buttons {
    display: flex;
    gap: 20px;
  }

  .cookies-bar-buttons-accept, .cookies-bar-buttons-reject {
    width: 100%;
  }

  :global(body.dark) .cookies-bar {
    background: var(--grey-8);

    box-shadow: 0 0 5px 0 var(--black);
  }

  @media only screen and (max-width: 500px) {
    .cookies-bar-content {
      height: 60px;
    }

    .cookies-bar-buttons {
      flex-direction: column;
    }
  }
</style>
